import styled, { css } from "styled-components";

export const PlayIconContainer = styled.div`
  --icon-size: 60px;
  position: absolute;
  top: calc(50% - (var(--icon-size) / 2));
  left: calc(50% - (var(--icon-size) / 2));

  cursor: inherit;
  pointer-events: none;

  & > svg {
    width: var(--icon-size);
    height: var(--icon-size);
  }
`;

export const Container = styled.div<{ $enabled: boolean }>`
  overflow: hidden;
  position: relative;

  width: 100%;
  height: 100%;
  ${({ $enabled }) => {
    return css`
      &:hover {
        cursor: ${$enabled ? "pointer" : "inherit"};
      }
    `;
  }}
`;

export const Thumbnail = styled.img.attrs({
  draggable: "false",
})<{
  $aspectRatio: "square" | "wide";
}>`
  object-fit: cover;
  aspect-ratio: ${({ $aspectRatio }) =>
    $aspectRatio === "square" ? "1/1" : "16/9"};
  width: 100%;
  cursor: inherit;
`;

export const Duration = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 4px;
  padding: 4px 6px;
  background-color: black;
  opacity: 0.6;
  color: white;
  user-select: none;
  backdrop-filter: blur(2px);
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-backdrop-filter: blur(2px);
  cursor: inherit;
`;

export const Caption = styled.div`
  position: absolute;
  color: white;
  border-radius: 4px;
  padding: 4px 6px;
  background-color: black;
  opacity: 0.6;
  user-select: none;
  backdrop-filter: blur(1px);
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-backdrop-filter: blur(1px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: max-content;
  max-width: calc(100% - 30px);
  left: 15px;
  right: 15px;
  bottom: 12px;
`;
